(function () {
    'use strict';

    angular.module("imApp").factory("shiftDayBreakService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 556,
                    parameters: parms || {}
                });
            },
            validateBreakHour: function (edit) {
                return $ihttp.post({
                    method: 559,
                    parameters: edit
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 557,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 558,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
